import { MeditatorStatus } from "@/constants";

export * from "./CancellationRequestRegistrants";
export * from "./Meditators";
export * from "./MeditatorsByRetreat";
export * from "./NewRegistrants";
export * from "./OldRegistrants";
export * from "./RegisteredMeditators";
export * from "./RegistrantGenderCountModal";
export * from "./RegistrantInformations";

export const getMeditatotStatusColor = (status: MeditatorStatus) => {
    switch (status) {
        case MeditatorStatus.PENDING:
            return "yellow";
        case MeditatorStatus.ACCEPTED:
            return "green";
        case MeditatorStatus.REJECTED:
            return "red";
        case MeditatorStatus.PASSED:
            return "blue";
        case MeditatorStatus.FAILED:
            return "red";
        case MeditatorStatus.DECLINE_PENDING:
            return "purple";
        case MeditatorStatus.DECLINE_CONFIRMED:
            return "cyan";
        case MeditatorStatus.DECLINE_REJECTED:
            return "magenta";
        default:
            return "default";
    }
}